import React, { useEffect, useState } from "react";
import AuditionHeading from "../Reuse/AuditionHeading";
import { BsCurrencyDollar } from "react-icons/bs";
import { AiFillAudio } from "react-icons/ai";
import AuditionIncomeCard from "../Reuse/AuditionIncomeCard";
import axios from "axios";

function AuditionSingleIncome() {
  const [totalAudition, setTotalAudition] = useState();
  const [pendingAudition, setPendingAudition] = useState();
  const [liveAudition, setLiveAudition] = useState();
  const [completedAudition, setCompletedAudition] = useState();

  useEffect(() => {
    axios.get(`/api/audition-admin/dashboard/audition/count`).then((res) => {
      if (res.data.status === 200) {
        setTotalAudition(res.data.totalAudition);
        setPendingAudition(res.data.pendingAudition);
        setLiveAudition(res.data.liveAudition);
        setCompletedAudition(res.data.completedAudition);
      }
    });
  }, []);

  return (
    <>
      <div className="row">
        <AuditionHeading title={"Audition"} icon={<AiFillAudio size={50} />} />
        <AuditionIncomeCard
          title={"Total"}
          amount={totalAudition}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <AuditionIncomeCard
          title={"Pending"}
          amount={pendingAudition}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <AuditionIncomeCard
          title={"Live"}
          amount={liveAudition}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <AuditionIncomeCard
          title={"Completed"}
          amount={completedAudition}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
      </div>
    </>
  );
}

export default AuditionSingleIncome;
